import dynamic from 'next/dynamic';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { InjectedIntlProps, injectIntl } from 'react-intl';
import Merchant from '../../../domain/entities/Merchant';
import {
  ActionsCreators as actions,
  Actions as IActions,
} from '../../../redux/actions/merchants/services';
import { State } from '../../../redux/reducers/merchants/services';
import * as T from '../../../redux/types/merchants/services';
import { TemplateProps } from '../common/BaseTemplate';
import { ComponentProps as FullCalendarProps } from './MerchantWidgetCalendar';

interface StateProps {
  baseDate: string;
  fetchedUntil: string;
  viewStyle: T.ViewStyle;
}

interface DispatchProps {
  actions: {
    handleCalendarClick: () => void;
    handleListClick: () => void;
    load: (
      publicId: T.PublicId,
      baseDate: string,
      fetchedUntil: string,
    ) => void;
    movePrev: () => void;
    moveNext: () => void;
    scrollNext: () => void;
  };
}

export interface PageProps extends TemplateProps {
  merchant: Merchant;
  calendarViewStyle: string;
  ga?: string;
  servicePublicIds?: number[];
}
type Props = StateProps & DispatchProps & PageProps & InjectedIntlProps;

const MerchantWidgetCalendar = dynamic<FullCalendarProps>(
  import('./MerchantWidgetCalendar').then(c => c.default),
  {
    loading: () => <span />,
    ssr: false,
  },
);

const MerchantWidgetCalendarPage: React.FC<Props> = ({
  baseDate,
  merchant,
  calendarViewStyle,
  ga,
  servicePublicIds,
}) => {
  return (
    <MerchantWidgetCalendar
      merchantPublicId={merchant.publicId}
      merchantTimeZone={merchant.timeZone}
      baseDate={baseDate as string}
      merchant={merchant}
      calendarViewStyle={calendarViewStyle}
      ga={ga}
      servicePublicIds={servicePublicIds}
    />
  );
};

const mapStateToProps = (state: { merchantsServices: State }): StateProps => {
  return { ...state.merchantsServices };
};

const mapDispatchToProps = (dispatch: Dispatch<IActions>): DispatchProps => ({
  actions: {
    handleCalendarClick: () =>
      dispatch(actions.switchViewStyle(T.ViewStyle.Calendar)),

    handleListClick: () => dispatch(actions.switchViewStyle(T.ViewStyle.List)),

    moveNext: () => dispatch(actions.moveNext()),

    movePrev: () => dispatch(actions.movePrev()),

    load: (publicId: string, baseDate: string, fetchedUntil: string) => {
      actions
        .load(publicId, baseDate, fetchedUntil)
        .then(ac => (ac ? dispatch(ac) : undefined));
    },

    scrollNext: () => {
      dispatch(actions.scrollNext());
    },
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MerchantWidgetCalendarPage));
